import { GroupSummaryReport } from './GroupSummaryReport';

/** Trial Balance: closing balance of every primary group (Detailed shows what's under it). */
export function TrialBalancePage() {
  return <GroupSummaryReport title="Trial Balance" roots="primaries" defaults={{}} trial />;
}

/** Group-wise Ledger Report: every group with its ledgers — opening, transactions, closing. */
export function GroupWisePage() {
  return <GroupSummaryReport title="Group Summary" roots="primaries" defaults={{ det: true, op: true, tx: true }} />;
}

/** Expense Report: Group Summary of Indirect Expenses. */
export function ExpenseReportPage() {
  return <GroupSummaryReport title="Indirect Expenses" roots={['Indirect Expenses']} defaults={{ tx: true }} />;
}

const INCOME = ['Sales Accounts', 'Direct Incomes', 'Indirect Incomes'];
/** Income Report: Group Summary of Sales Accounts and the incomes. */
export function IncomeReportPage() {
  return <GroupSummaryReport title="Income" roots={INCOME} defaults={{ det: true, tx: true }} />;
}
